module.exports = __webpack_public_path__ + "static/OneDotCd-Bold.75d1897c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotCd-Bold.woff
// module id = 739
// module chunks = 114276838955818